// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  //  endpoint_url: "https://howdyappdev.azurewebsites.net/api/",
  //MOCK URL
  //endpoint_url: 'https://private-a36d17-tntportalapiblueprint.apiary-mock.com/api/v1/',
  //SPRING URL
  // endpoint_url: 'http://bdp-uat-mysql.eastus.cloudapp.azure.com:9999/api/v1/',
  //BEANSTACK DEV URL

  //BEANSTACK UAT URL
  // endpoint_url: 'http://tntservice-uat.us-east-1.elasticbeanstalk.com/api/v1/',
  //localHost URL
  //endpoint_url: 'http://localhost:9999/api/v1/',
  auth_endpoint_url: 'http://cozentusutilityvm5.southeastasia.cloudapp.azure.com:8081/api/v1/',
  risk_monitor_demo_url: 'https://psabdp.com/what-we-do/visibility-tools/smart-navigator/risk-monitor',
  //  endpoint_url:'https://private-cbf2c-bdpleadtimecalculator.apiary-mock.com/api/v1/',
  mapbox: {
    accessToken: 'pk.eyJ1IjoiZ3JhbnRya29jaCIsImEiOiJjbXY5bGZ0cnAwMGI0MnhwczBtdDBnYnYwIn0.M71esxz6SJz8HVBY8mlVOA'
  },
  //REQUIRED - Amazon Cognito RegionW
  awsCognitoRegion: "us-east-1",
  //OPTIONAL - Amazon Cognito User Pool Id
  awsCognitoUserPoolId: "us-east-1_Rwm3dAR7J",
  //OPTIONAL - Amazon Cognito Web Client Id
  awsCognitoUserPoolWebClientId: "2bqr4np6rsa80dqjq67a7da58s",
  //OPTIONAL - Amazon Cognito Web Client Flow Type
  awsCognitoAuthenticationFlowType: "USER_PASSWORD_AUTH",

  qlik_dashboard:'https://navigator.bdpsmart.com/qlik/',
  qlik_selfservice:'https://navigator.bdpsmart.com/qlik/assets/',
  //Url For 8723 Dev Enviroment



  smart_url: 'https://www.bdpsmart.com',
  //Url For 8725 Test Enviroment
  // endpoint_url: 'http://tntportalservicesystemtest-env.eba-8dgrvkyr.us-east-1.elasticbeanstalk.com/api/v1/',
  // portalendpoint_url: 'http://tntportaluserservicesystemtest-env.eba-bkmqe3jy.us-east-1.elasticbeanstalk.com/api/v1/'

  //Url For 8727 Test Enviroment
  // endpoint_url: 'http://tntportalservicedemo-env.us-east-1.elasticbeanstalk.com/api/v1/',
  // portalendpoint_url: 'http://tntuserservicedemo-env.us-east-1.elasticbeanstalk.com/api/v1/'

  //Url For Pilot Test Enviroment
  // endpoint_url: 'http://tntportalservice-env.eba-wdujy3vu.us-east-2.elasticbeanstalk.com/api/v1/',
  // portalendpoint_url: 'http://tntuserservicedev-env.eba-sya9ndaw.us-east-2.elasticbeanstalk.com/api/v1/'

  //Url For Air Environment
  air_endpoint_url: 'https://air.bdpsmart.com/air/portal-service/api/v1/',
  air_portalendpoint_url: 'https://air.bdpsmart.com/air/user-service/api/v1/',
  air_demo_url: 'http://localhost:4200/#/app/air',
  //URL of Navigator Calls
  endpoint_url: 'https://navigator.bdpsmart.com/portal-api/api/v1/',
  portalendpoint_url: 'https://navigator.bdpsmart.com/portal-user-api/api/v1/',
  navigatorlogoutUrl:  'https://navigator.bdpsmart.com/#/app-logout',
  navigatorloginUrl: 'https://navigator.bdpsmart.com'  //------/#/app-logout
}
